import { actionTypes } from "../utils";

export const types = {
  ...actionTypes('GET_REPORTS_BY_ORG_ID'),
};